export function getSelector (paths) {
  if (Array.isArray(paths)) {
    return paths.reverse().filter(element => {
      return element !== document && element !== window
    }).map(element => {
      if (element.id) {
        return `${element.nodeName.toLowerCase()}#${element.id}`
      } else if (element.className && typeof element.className === 'string') {
        return `${element.nodeName.toLowerCase()}.${element.className}`
      } else {
        return element.nodeName.toLowerCase()
      }
    }).join(' ')
  }
}

export function getLines (stack) {
  return stack.split('\n').slice(1).map(x => x.replace(/^\s+at\s+/g, '')).join('^')
}
